var ___EXPOSE_LOADER_IMPORT___ = require("-!./gamper-4-item-triad.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../../../../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["sdbb_gamper_4_page_item_triad"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["sdbb_gamper_4_page_item_triad"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
